export const BACKEND_BASE_URL = window.env.API_URL
export const VERSION_APP = '1.3.0'
